import { render, staticRenderFns } from "./AdminCardsIndexPage.vue?vue&type=template&id=814d9e84"
import script from "./AdminCardsIndexPage.vue?vue&type=script&lang=js"
export * from "./AdminCardsIndexPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports